import React from 'react';
import PropTypes from 'prop-types';
/* components */
import ScrollArea from '../../components/scroll-area/scroll-area';

function ErrorPage(props) {
    const { model } = props;
    return (
        <div className="sten-content">
            <div className="sten-content__header">
                <h1 className="sten-content__title text-uppercase text-danger">Error</h1>
            </div>
            <ScrollArea className="sten-content__body sten-content__body--with-bg">
                <section className="sten-content__section">
                    <h3 className="text-danger">Some error occurred</h3>
                </section>
                <section className="sten-content__section">
                    {model && model.error && (
                        <div className="flex-row">
                            <label className="label flex-shrink">{model.error.error}: </label>
                            {model.error.errorDescription && (
                                <label className="label label--value flex-shrink text-danger">
                                    {model.error.errorDescription}
                                </label>
                            )}
                        </div>
                    )}
                    {model && model.requestId && (
                        <div className="flex-row">
                            <label className="label flex-shrink">Request Id: </label>
                            <label className="label label--value flex-shrink">{model.requestId}</label>
                        </div>
                    )}
                </section>
                {model && model.returnUrl && (
                    <section className="sten-content__section">
                        <p>Click <a href={model.returnUrl}>here</a> to try again.</p>
                    </section>
                )}
            </ScrollArea>
        </div>
    );
}

ErrorPage.propTypes = {
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default ErrorPage;
